/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const ResourceType = core.serialization.enum_([
    "account",
    "application",
    "document",
    "email",
    "environment",
    "event",
    "file",
    "guest",
    "job",
    "mapping_family",
    "mapping_program",
    "mapping_rule",
    "plan",
    "record",
    "commit",
    "sheet",
    "snapshot",
    "space_config",
    "space",
    "subscription",
    "user",
    "workbook",
    "agent",
    "agent_log",
    "field",
    "cell",
    "workbook_config",
    "api_key",
    "secret",
    "billing_subscription",
    "role",
    "actor_role",
    "permission",
    "data_retention_policy",
    "oauth_client",
    "oauth_grant",
    "oauth_code",
    "prompts",
]);
